import { createContext, useContext, useReducer } from "react";
import { carReducer } from "./car-reducer";

export const CarContext = createContext();

export const CarContextProvider = ({ children }) => {
  const [cars, dispatch] = useReducer(carReducer, null);
  return (
    <CarContext.Provider value={{ cars, dispatch }}>
      {children}
    </CarContext.Provider>
  );
};

export const useCarContext = () => useContext(CarContext);

